<template>
  <div class="container">
    <p class="title" :style="{marginTop: '1.5rem'}" v-if="loading === true">Verifying your payment...</p>
    <div v-if="loading === true">
      <b-loading :is-full-page="true" :active.sync="loading" :can-cancel="false"></b-loading>
    </div>
    <div v-if="succeeded === true">
      <p :style="{marginTop: '1.5rem'}">Payment succeeded, thanks for signing up! You should have just received an email from PayPal!</p>
    </div>
    <div v-if="succeeded === false">
      <p :style="{marginTop: '1.5rem'}">
        If you received an email from PayPal (at the email you specified for PayPal) that you paid, that means you're all set and your're good to go.<br>
        If you haven't received an email but think you paid, please email us at <a href="mailto:thebeachatsharkeys@gmail.com">thebeachatsharkeys@gmail.com</a>
      </p>
    </div>
  </div>
</template>

<script>
import nestedRouterRetriever from '@/mixins/nestedRouterRetriever.js'
import paymentChecker from '@/mixins/paymentChecker.js'

export default {
  name: "SignupCampFinished",
  mixins: [nestedRouterRetriever, paymentChecker],
  computed: {
    camper() {
      let campers = this.camp.campers;
      let id = this.$route.params.camperId;
      return campers.filter(camper => camper != null && camper.id == id)[0];
    }
  },
  data() {
    return {
      loading: true,
      succeeded: null,
    }
  },
  created() {
    this.setupPaymentChecker(`${this.$apiRoot}/paypal/is-payment-complete/?payment_uuid=${this.camper.paymentUuid}`)
  }
}
</script>